import versionInfo from "../../public/version.json";

export const APP_INFO = {
    appName: "Medinvoice",
    legalName: "exipnon GmbH",
    taxNumber: "114/125/90270",
    vatId: "DE463980466",
    email: "medinvoice@medinvoice.io",
    tel: "0123456789",
    version: versionInfo.version,
};
